module.exports = __webpack_public_path__ + "static/img/nai.7f69b241.png";